/*
 * @Name: Desert
 * @Date: 2024-05-29 12:00:27
 * @Creator: gods
 * @Description: you're the better!!
 */
export const Whitelist = ['/improve-account']
